module.exports = __webpack_public_path__ + "media/luxury-2026/floor-kitchen-960-4352bed9.jpg";